import '@wordpress/element';
import MicroModal from 'micromodal';

MicroModal.init({
    onShow: modal => {
        const liteVideos = modal.querySelectorAll('lite-youtube, lite-vimeo');
        if (modal.dataset.autoplayVideo == 'autoplay') {
            liteVideos.forEach(el => {
                el.dispatchEvent(new MouseEvent('click', { bubbles: true }));
            });
        }
    },
    onClose: modal => {
        const liteVideos = modal.querySelectorAll('lite-youtube, lite-vimeo');
        liteVideos.forEach(el => {
            const shadow = el.shadowRoot;
            const iframes = shadow.querySelectorAll('iframe');
            iframes.forEach((iframe) => {
                let currentSrc = iframe.src;
                currentSrc = currentSrc.replace(/([?&])autoplay=1(&)?/, (match, p1, p2) => {
                    if (p1 === '?' && !p2) return '?';
                    if (p1 === '&' && !p2) return '';
                    return p1;
                }).replace(/[?&]$/, ''); 
                iframe.src = '';
                setTimeout(() => {
                    iframe.src = currentSrc;
                }, 100); 
            });
        });
    },
    openTrigger: 'data-custom-open', 
    openClass: 'is-open', 
    disableScroll: true, 
    disableFocus: false, 
    awaitOpenAnimation: false, 
    awaitCloseAnimation: false,
    debugMode: true 
});

document.addEventListener('DOMContentLoaded', function () {
    document.body.addEventListener('click', function (e) {
        const link = e.target.closest('a[data-custom-open]');
        if (link && link.getAttribute('href') && link.getAttribute('href').startsWith('#modal-')) {
            e.preventDefault();
        }
    });
});